<script lang="ts" setup>
	import { cn } from '@/helpers/cn'

	interface Props {
		class?: string
	}

	const props = defineProps<Props>()
</script>

<template>
	<thead
		:class="cn('bg-gray-50 uppercase text-xs font-semibold p-4', props.class)"
	>
		<slot />
	</thead>
</template>
